import type { User } from '@/lib/pr-v2/timeline-types';
import type { Collaborators } from '@/types/github';

export function mapCollaboratorsToUsers(collaborators: Collaborators | null | undefined): User[] {
  if (!collaborators) {
    return [];
  }
  return collaborators.map((collaborator) => ({
    login: collaborator.login,
    avatar_url: collaborator.avatar_url,
    html_url: collaborator.html_url,
  }));
}
